import { DATE_FORMAT } from '@ui-framework/index';
import dayjs from 'dayjs';
import JobStatus from '../../../JobStatus';

function createdBy(original) {
  if (original?.description) {
    return original?.description;
  }

  return `${original?.statusChangedByUser?.firstName || ''} ${original?.statusChangedByUser?.lastName || ''}`;
}

function changedDate(original) {
  return original?.statusChangeDateTime
    ? dayjs(original?.statusChangeDateTime).format(DATE_FORMAT.LONG_DATE)
    : '';
}

function oldJobStatus(original) {
  return <JobStatus component="span">{original?.oldJobStatus}</JobStatus>;
}

function newJobStatus(original) {
  return <JobStatus component="span">{original?.newJobStatus}</JobStatus>;
}

export { createdBy, changedDate, oldJobStatus, newJobStatus };
